import Typography from "typography";

export const typography = new Typography({
    baseFontSize: "18px",
    headerLineHeight: 1.4,
});

